<template>
    <div class="acuAdminReport">
        <div :style="`z-index: 9999; position: absolute; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}; width: auto`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiChartBox }}
            </v-icon>
            <span>Reports</span>
        </h1>
        <v-card
            class="docInfoBody"
            elevation="10"
            style="margin: 2% auto 0 auto; position: relative;"
        >
            <v-card-title style="height: 80px; margin: 0; padding: 0;">
                <v-row style="margin: 0; padding: 0;">
                    <v-col cols="8" style="margin: 0; padding: 0;">
                        <v-card style="margin: 0; padding: 20px" elevation="2">
                            <v-row>
                                <v-col cols="4" style="height: 45px;">
                                    <v-text-field
                                        v-model="frDate"
                                        dense
                                        color="teal darken-1"
                                        type="date"
                                        label="FR DATE"
                                        :disabled="loading"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="4" style="height: 45px;">
                                    <v-text-field
                                        v-model="toDate"
                                        dense
                                        color="teal darken-1"
                                        type="date"
                                        label="TO DATE"
                                        :disabled="loading"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="2" style="padding: 0; margin-top: 7px; text-align: center">
                                    <v-btn
                                        :disabled="loading"
                                        style="min-width: 0; width: 10px; padding: 17px 21px;"
                                        color="teal darken-1 white--text"
                                        @click="handleRunFilter()"
                                    >
                                        <v-icon>{{ mdiFilter }}</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="2" style="padding: 0; margin-top: 7px;">
                                    <v-btn
                                        :disabled="loading"
                                        style="min-width: 0; width: 10px; padding: 17px 21px;"
                                        color="teal darken-1 white--text"
                                        @click="downloadReport()"
                                    >
                                        <v-icon>{{ mdiDownload }}</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="3" style="padding-top: 23px;">
                        <v-text-field
                            v-model="searchQuery"
                            dense
                            :disabled="loading"
                            color="teal darken-1"
                            :append-icon="mdiMagnify"
                            clearable
                            hide-details
                            label="Search"
                            @click:append="search=searchQuery"
                            @keydown.enter="search=searchQuery"
                            @click:clear="search=''"
                        />
                        <div
                            v-if="!filter.acu.status"
                            style="position: absolute; right: 7%; top: 47px;"
                            cols="1"
                        >
                            <v-tooltip top>
                                <template #activator="{ on }">
                                    <v-btn
                                        elevation="2"
                                        color="success white--text"
                                        :disabled="loading"
                                        icon
                                        v-on="on"
                                        @click="filter.acu.status = true"
                                    >
                                        <v-icon>{{ mdiFilterPlus }}</v-icon>
                                    </v-btn>
                                </template>
                                <span>Add Filter</span>
                            </v-tooltip>
                        </div>
                        <div
                            v-else
                            style="position: absolute; right: 7%; top: 47px;"
                            cols="1"
                        >
                            <v-tooltip top>
                                <template #activator="{ on }">
                                    <v-btn
                                        elevation="2"
                                        color="error white--text"
                                        :disabled="loading"
                                        icon
                                        v-on="on"
                                        @click="handleRemoveFilter"
                                    >
                                        <v-icon>{{ mdiFilterRemove }}</v-icon>
                                    </v-btn>
                                </template>
                                <span>Remove Filter</span>
                            </v-tooltip>
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-expand-transition>
                <v-card-title v-show="filter.acu.status">
                    <v-row>
                        <v-col cols="4" style="margin: 0; padding: 0 10px">
                            <v-text-field
                                v-model="filter.acu.msu"
                                hide-details
                                color="teal darken-1"
                                dense
                                label="MSU Code"
                                placeholder="000"
                                clearable
                                :disabled="loading"
                                @click:clear="handleRunFilter('filter.acu.msu')"
                                @keyup.enter="handleRunFilter()"
                            />
                        </v-col>
                        <v-col cols="4" style="margin: 0; padding: 0 10px">
                            <v-text-field
                                v-model="filter.acu.acctN"
                                hide-details
                                color="teal darken-1"
                                dense
                                label="Account Number"
                                placeholder="00000"
                                clearable
                                :disabled="loading"
                                @click:clear="handleRunFilter('filter.acu.acctN')"
                                @keyup.enter="handleRunFilter()"
                            />
                        </v-col>
                        <v-col cols="4" style="margin: 0; padding: 0 10px">
                            <v-text-field
                                v-model="filter.acu.membN"
                                hide-details
                                color="teal darken-1"
                                dense
                                label="Member Number"
                                placeholder="000000"
                                clearable
                                :disabled="loading"
                                @click:clear="handleRunFilter('filter.acu.membN')"
                                @keyup.enter="handleRunFilter()"
                            />
                        </v-col>
                    </v-row>
                </v-card-title>
            </v-expand-transition>
            <v-card-subtitle style="margin-top: 0; height: 40px">
                <v-tabs
                    v-model="currentItem"
                    style="margin-top: 5px;"
                    slider-color="teal darken-1"
                    grow
                    height="40"
                    color="teal darken-1"
                >
                    <v-tab
                        v-for="itemTab in items"
                        :key="itemTab"
                        :disabled="loading"
                        :href="'#tab-' + itemTab"
                    >
                        {{ itemTab }}
                    </v-tab>
                </v-tabs>
            </v-card-subtitle>
            <v-tabs-items v-model="currentItem">
                <v-tab-item
                    v-for="(itemTab, indexTab) in items"
                    :key="itemTab"
                    :value="'tab-' + itemTab"
                >
                    <span
                        v-if="currentItem === 'tab-APPROVAL LOGS' && data && data.length > 0"
                        style="background-color: white; color: #666; position: absolute; z-index: 10; right: 0; height: 31.80px; width: 78px; border-radius: 0 5px 0 0; text-align: center; font-family: Montserrat, sans-serif; font-size: 12px; font-weight: 600; padding-top: 5px; border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                    >Action</span>
                    <span
                        v-if="currentItem === 'tab-APPROVAL LOGS' && data && data.length > 0"
                        style="background-color: white; color: #666; position: absolute; z-index: 10; right: 77px; height: 31.80px; width: 87px; text-align: center; font-family: Montserrat, sans-serif; font-size: 12px; font-weight: 600; padding-top: 5px; border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                    >Status</span>
                    <v-data-table
                        :ref="`dataTabletest_${indexTab}`"
                        :search="search"
                        :loading="loading ? '#009688' : null"
                        dense
                        item-key="Approval No."
                        :items="data"
                        :headers="modifiedHeaders"
                        :class="`nowrap-table ${currentItem === 'tab-APPROVAL LOGS' ? data && data.length > 0 ? 'acuTbl' : '' : ''} acuReportTbl`"
                        :footer-props="{
                            'items-per-page-options': [10, 20, 30, 40, 50, 100],
                            'items-per-page-text': ''
                        }"
                        fixed-header
                        @pagination="onPaginationChange"
                    >
                        <template #item="{ item }">
                            <tr>
                                <td
                                    v-for="(key, index) in modifiedHeaders"
                                    :key="index"
                                    style="white-space: nowrap;"
                                >
                                    {{ item[key.value] }}
                                </td>
                                <td v-if="currentItem === 'tab-APPROVAL LOGS' && data && data.length > 0">
                                    <v-tooltip
                                        top
                                        style="z-index: 100;"
                                    >
                                        <template #activator="{ on }">
                                            <v-btn
                                                :disabled="loading"
                                                style="min-width: 0; padding: 0 10px; margin: 0"
                                                color="teal darken-1"
                                                class="white--text"
                                                v-on="on"
                                                @click="downloadOpan(item)"
                                            >
                                                <v-icon>{{ mdiDownload }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Download Approval</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
import { saveAs } from 'file-saver'
import { moment } from '../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import { 
    mdiChartBox,
    mdiFilter,
    mdiDownload,
    mdiMagnify,
    mdiFilterPlus,
    mdiFilterRemove
} from '@mdi/js'
import { base64ToBlob } from '../../../utils/helpers'
export default {
    data () {
        return {
            mdiChartBox,
            mdiFilter,
            mdiDownload,
            mdiMagnify,
            mdiFilterPlus,
            mdiFilterRemove,
            filter: {
                acu: {
                    status: false,
                    msu: '',
                    acctN: '',
                    membN: ''
                }
            },
            notif: {
                show: false,
                type: 'success',
                msg: 'Done',
                color: 'success'
            },
            searchQuery: null,
            search: null,
            loading: false,
            frDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            currentItem: 'tab-AT GLANCE',
            currentDownloadOpanNo: null,
            currentTabForAutoScrollStart: [],
            items: [
                'AT GLANCE', 'APPROVAL LOGS', 'DISAPPROVAL LOGS', 'MEMBER SUMMARY', 'ACCOUNT SUMMARY', 'PROVIDER LOGIN LIST'
            ],
            headers: [],
            data: [],
            screen_width: document.documentElement.clientWidth + 9
        }
    },
    computed: {
        // ...mapGetters([ 'showMemberLoginListData', 'showMemberApprovalLogsData', 'showMemberDisapprovalLogsData', 'showMemberSummaryTableData', 'showAccountSummaryTableData', 'showMemberAtGlanceData', 'downloadReportMembData', 'downloadApprovalMembData']),
        ...mapGetters(['fetchAcuApprovalLogsData', 'fetchAcuDisapprovalLogsData', 'fetchAcuMemberSummaryData', 'fetchAcuAccountSummaryData', 'fetchAcuProviderLoginListData', 'showAcuAtGlanceData', 'generateAcuReportData', 'downloadAcuApprovalData']),
        modifiedHeaders() {
            // Return a new array without the last element
            if (this.currentItem === 'tab-APPROVAL LOGS') {
                return this.headers.slice(0, -1)
            } else {
                return this.headers
            }
        }
    },
    watch: {
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        },
        downloadAcuApprovalData(newVal) {
            this.loading = false
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Download Complete!'
                    this.notif.show = true
                    this.handleFileDownload(newVal.data, `${this.currentDownloadOpanNo.OPAN_N}-${this.currentDownloadOpanNo.MEMBN}.pdf`)
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        generateAcuReportData(newVal) {
            this.loading = false
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Download Complete!'
                    this.notif.show = true
                    this.handleFileDownload(newVal.data, `AcuReport${this.frDate}--${this.toDate}.xlsx`)
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        searchQuery(newVal) {
            if (newVal === '' || newVal === undefined || newVal === null) this.search = ''
        },
        async currentItem(newVal) {
            if (newVal) {
                const params = { FR_DATE: this.frDate, TO_DATE: this.toDate, MSU_C: this.filter.acu.msu, ACCT_N: this.filter.acu.acctN, MEMB_N: this.filter.acu.membN }
                await this.getData(newVal, params)
            }
        }
    },
    async mounted(){
        window.addEventListener('resize', this.onResize)
        this.getData(this.currentItem, { FR_DATE: this.frDate, TO_DATE: this.toDate, MSU_C: this.filter.acu.msu, ACCT_N: this.filter.acu.acctN, MEMB_N: this.filter.acu.membN })
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        // ...mapActions([ 'getCsrfToken', 'showMemberLoginList', 'showMemberApprovalLogs', 'showMemberDisapprovalLogs', 'showMemberSummaryTable', 'showAccountSummaryTable', 'showMemberAtGlance', 'downloadReportMemb', 'downloadApprovalMemb']),
        ...mapActions(['getCsrfToken', 'fetchAcuApprovalLogs', 'fetchAcuDisapprovalLogs', 'fetchAcuMemberSummary', 'fetchAcuAccountSummary', 'fetchAcuProviderLoginList', 'showAcuAtGlance', 'generateAcuReport', 'downloadAcuApproval']),
        onPaginationChange() {
            this.scrollToTop()
        },
        scrollToTop() {
            if (!this.currentTabForAutoScrollStart.includes(this.currentItem)) {
                this.currentTabForAutoScrollStart.push(this.currentItem)
            }
            this.$nextTick(() => {
                let currentIndex = this.currentTabForAutoScrollStart.indexOf(this.currentItem)
                const currentTableRef = `dataTabletest_${currentIndex}`
                if (this.$refs[currentTableRef]) {
                    const tableElement = this.$refs[currentTableRef][0].$el

                    // Try to find the actual table header row
                    const headerRow = tableElement.querySelector('thead tr') ||
                        tableElement.querySelector('.v-data-table-header tr') ||
                        tableElement.querySelector('tr')

                    if (headerRow) {
                        headerRow.scrollIntoView({
                            // behavior: 'smooth',
                            block: 'start'
                        })
                    } else {
                        // Fallback to table element
                        tableElement.scrollIntoView({
                            // behavior: 'smooth',
                            block: 'start'
                        })
                    }
                }
            })
        },
        handleRunFilter(path) {
            // Clear the field manually
            if (path) {
                this.setByPath(this, path, '')
            }
            this.$nextTick(() => {
                const params = { FR_DATE: this.frDate, TO_DATE: this.toDate, MSU_C: this.filter.acu.msu, ACCT_N: this.filter.acu.acctN, MEMB_N: this.filter.acu.membN }
                this.getData(this.currentItem, params)
            })
        },
        setByPath(obj, path, value) {
            const keys = path.split('.')
            let target = obj
            for (let i = 0; i < keys.length - 1; i++) {
                target = target[keys[i]]
            }
            target[keys[keys.length - 1]] = value
        },
        handleRemoveFilter() {
            this.filter.acu = {
                status: false,
                msu: '',
                acctN: '',
                membN: ''
            }
            this.handleRunFilter()
        },
        downloadOpan(data) {
            this.loading = true
            this.currentDownloadOpanNo = { OPAN_N: data['Approval No.'], MEMBN: data['Member No.'] }
            this.downloadAcuApproval({ OPAN_N: data['Approval No.'] })
        },
        downloadReport() {
            this.loading = true
            this.generateAcuReport({ FR_DATE: this.frDate, TO_DATE: this.toDate, MSU_C: this.filter.acu.msu, ACCT_N: this.filter.acu.acctN, MEMB_N: this.filter.acu.membN })
        },
        // Utility function to handle file download
        handleFileDownload(data, fileName) {
            try {
                const blob = base64ToBlob(data.file, data.type)
                const url = URL.createObjectURL(blob)
                saveAs(blob, fileName)
                URL.revokeObjectURL(url) // Clean up the URL object
            } catch (err) {
                // console.error('err: ', err)
            }
        },
        async getData(name, params = null) {
            this.headers = []
            this.data = []
            this.loading = true
            let sortable = false
            // await this.getCsrfToken()
            if (name === 'tab-AT GLANCE') {
                await this.showAcuAtGlance(params)
                this.data = this.showAcuAtGlanceData && this.showAcuAtGlanceData.data ? [this.showAcuAtGlanceData.data] : null
                sortable = false
            } else if (name === 'tab-APPROVAL LOGS') {
                await this.fetchAcuApprovalLogs(params)
                let temp = this.fetchAcuApprovalLogsData && this.fetchAcuApprovalLogsData.data ? this.fetchAcuApprovalLogsData.data : []
                this.data  = temp.map(element => {
                    return { ...element, selected: false }
                })
                sortable = true
            } else if (name === 'tab-DISAPPROVAL LOGS') {
                await this.fetchAcuDisapprovalLogs(params)
                this.data = this.fetchAcuDisapprovalLogsData && this.fetchAcuDisapprovalLogsData.data ? this.fetchAcuDisapprovalLogsData.data : []
                sortable = true
            } else if (name === 'tab-MEMBER SUMMARY') {
                await this.fetchAcuMemberSummary(params)
                this.data = this.fetchAcuMemberSummaryData && this.fetchAcuMemberSummaryData.data ? this.fetchAcuMemberSummaryData.data : []
                sortable = true
            } else if (name === 'tab-ACCOUNT SUMMARY') {
                await this.fetchAcuAccountSummary(params)
                this.data = this.fetchAcuAccountSummaryData && this.fetchAcuAccountSummaryData.data ? this.fetchAcuAccountSummaryData.data : []
                sortable = true
            } else if (name === 'tab-PROVIDER LOGIN LIST') {
                await this.fetchAcuProviderLoginList(params)
                this.data = this.fetchAcuProviderLoginListData && this.fetchAcuProviderLoginListData.data ? this.fetchAcuProviderLoginListData.data : []
                sortable = true
            }
            this.headers = (this.data).length > 0 ? Object.keys(this.data[0]).map(key => ({
                text: key,
                value: key,
                sortable,
                class: 'headerAcuReport'
            })) : []
            this.loading = false
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style>
.acuTbl > div > table > tbody > tr > td:nth-last-child(2) {
    position: sticky !important;
    position: -webkit-sticky !important;
    right: 76px;
    z-index: 1;
    background-color: white;
}
.acuTbl > div > table > tbody > tr > td:last-child {
    position: sticky !important;
    position: -webkit-sticky !important;
    right: 0;
    z-index: 1;
    background: white;
}
.acuAdminReport h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.acuAdminReport .docInfoBody {
    margin-top: 5%;
    padding: 2% 3% 3% 3%;
}
.headerAcuReport {
    text-wrap: nowrap;
}
</style>
